import {
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';
import { NgIf } from '@angular/common';
import { CollectionDasboardMetricsComponent } from './collection-dasboard-metrics/collection-dasboard-metrics.component';
import { ExternalDashboardComponent } from './external-dashboard/external-dashboard.component';

@Component({
	selector: 'app-home-dashboard',
	templateUrl: './home-dashboard.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./home-dashboard.component.scss'],
	imports: [
		NgIf,
		CollectionDasboardMetricsComponent,
		ExternalDashboardComponent,
	],
})
export class HomeDashboardComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();

	constructor(private store: Store<State>) {}
	// @Output() agencyIdSent = new EventEmitter<string>();

	currentUser: User | null = null;
	adminView: any;
	isExternalView: boolean;
	agencyIdSent: string;
	viewApplicationLink: boolean;
	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.currentUser = user;
					this.adminView =
						user.permissions?.collection_dashboard_metrics === null
							? false
							: user.permissions?.collection_dashboard_metrics; // Defining Admin from the permission_component table
					this.isExternalView = user.roleID === 12;
					// this.agencyIdSent.emit(user.agency_zoho_id);
					this.agencyIdSent = user.agency_zoho_id;
					this.viewApplicationLink =
						user.externalPermission?.application_link === true;
				}
			});
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
